const io = require('socket.io-client')
export const socket = io(process.env.REACT_APP_HOST, {})

// Rooms live on the server's side of one connection: after a reconnect (a network blip, the
// server restarting) the new connection is in none of them, and the page silently stops
// getting updates. Subscriptions made through joinRoom are sent again on every reconnect,
// until the function it returns is called.
const rooms = new Set()

socket.io.on('reconnect', () => {
  rooms.forEach((args) => socket.emit(...args))
})

// joinRoom('subscribe session', sessionId, userId) -> leave()
export const joinRoom = (...args) => {
  socket.emit(...args)
  rooms.add(args)
  return () => {
    rooms.delete(args)
  }
}
